import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import {
  AddBrandApi,
  AddCategoryToBrandApi,
  AddImeiDetailsApi,
  AddProductToCategoryApi,
  AddTicketApi,
  baseurl,
  GetImeiDetailsApi,
  getProfileApi,
  GetSubUserProfileApi,
  SetLimitCheckApi,
} from "../Utility/Api";

const DefaultServiceModel = (props) => {
  const [showModal, setShowModel] = useState(false);
  const [showModal1, setShowModel1] = useState(false);

  const [defaultServices, setDefaultServices] = useState([]);

  const [loading, setLoading] = useState(false);
  const [expandedCategoryIndex, setExpandedCategoryIndex] = useState(0);
  const [categoryName, setCategoryName] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [subcategoryName, setSubcategoryName] = useState("");
  const [subcategoryNames, setSubcategoryNames] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [subcategoryId, setSubcategoryId] = useState("");
  const [editedFields, setEditedFields] = useState({});

  const [adminState, setAdminState] = useState("");
  const [selectedSubcategories, setSelectedSubcategories] = useState({});
  const navigate = useNavigate();

  const handleCategoryClick = (index) => {
    setExpandedCategoryIndex((prevIndex) =>
      prevIndex === index ? null : index
    );
  };

  useEffect(() => {
    console.log("new reapir props", props);
    let localAdmin = localStorage.getItem("admin");

    setAdminState(localAdmin);
    GetAllDefaultServices();
  }, []);

  const GetAllDefaultServices = () => {
    const userid = localStorage.getItem("userId");
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getDefaultServices`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log(result);
        if (result.status && result.data?.length > 0) {
          setDefaultServices(result.data[0].services);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const AddSubCategory = () => {
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      categoryId: selectedCategoryId,
      subcategory: subcategoryName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}addsubcategory`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        GetAllDefaultServices();
        setShowModel1(false);
      })
      .catch((error) => console.error(error));
  };

  const AddCategory = () => {
    let local = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      category: categoryName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}addCategory`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //  console.log(result);
        GetAllDefaultServices();

        setShowModel(false); // Close modal on success
        setCategoryName(""); // Reset input
      })
      .catch((error) => console.error(error));
  };

  const UpdateSubCategory = () => {
    let local = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      updatedService: {
        categoryId: selectedCategoryId,
        subcategoryId: subcategoryId,
        newSubcategoryName: subcategoryName,
      },
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${baseurl}updateDefaultServices`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //console.log(result);
        GetAllDefaultServices(); // Refresh list
        setShowModel1(false); // Close modal
        setSubcategoryName(""); // Clear input
        setIsEditMode(false); // Reset input
      })
      .catch((error) => console.error(error));
  };

  const handleSaveChanges = () => {
    let local = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const updates = Object.values(editedFields).map((update) => {
      const { price = 0, cost = 0, stock = 0 } = update;
      const profit = price - cost;
      const margin = price !== 0 ? Math.round((profit / price) * 100) : 0;

      return {
        ...update,
        profit,
        margin,
        stock: Number(stock),
        cost: Number(cost),
        price: Number(price),
      };
    });

    updates.forEach((update) => {
      const raw = JSON.stringify({
        updatedService: update,
      });

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      // console.log("uddafsd", raw);

      fetch(`${baseurl}updateDefaultServices`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          //console.log("Updated:", result);
          GetAllDefaultServices();
        })
        .catch((error) => console.error("Error updating:", error));
    });

    //   alert("All updates sent!");
    //   setEditedFields({});
  };

  const AddTicket = () => {
    let serviceId1Data = [];

    defaultServices.forEach((categoryItem) => {
      const selectedSubItems = categoryItem.subcategories.filter(
        (subItem) => selectedSubcategories[`${categoryItem.id}_${subItem.id}`]
      );

      if (selectedSubItems.length > 0) {
        serviceId1Data.push({
          id: categoryItem.id,
          name: categoryItem.category,
          subcategories: selectedSubItems.map((subItem) => subItem.name),
        });
      }
    });
    if (!props?.prop?.customer || serviceId1Data.length === 0) {
      Swal.fire("Please select Customer and at least one Service.");
      return;
    }
    setLoading(true);
    let local = localStorage.getItem("token");
    let userid = localStorage.getItem("userId");
    let subuserid = localStorage.getItem("subuserId");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      customerId: props?.prop?.customer,
      customerDeviceId: props?.productid.toString(),
      brandId: props?.brandid,
      serviceId1: serviceId1Data,
      categoryId: props?.seriesid.toString(),
      serviceId2: 0,
      statusOptionId: props?.prop?.status,
      techAssignedId: adminState === "0" ? subuserid : userid,
      salesPersonId: adminState === "0" ? subuserid : userid,
      dueDate: props?.prop?.date,
      password: props?.prop?.password,
      description: props?.prop?.note,
      drivingLicence: props?.prop?.driver,

      bin: props?.prop?.binid,

      isAdmin: adminState,
      isTechAdmin: adminState,
      isSalesPersonAdmin: adminState,
      techAssignedName: props?.prop?.assigned,
      repairTaskType: props?.prop?.repairid,
      warrantyApplicable: props?.prop?.warrantyid,
      imeiOrSerial: props?.prop?.imei,
      pattern: {
        patternType: "patteren",
        patternValue: props?.prop?.patteren,
      },
      image: props?.prop?.imageurl,
      preRepairChecklist: props?.prop?.checklist,
      additionalInfo: props?.prop?.additional,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    console.log("adddticket raww", raw);

    // fetch(AddTicketApi, requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     console.log("ticket add result", result);
    //     if (result?.status === true) {
    //       document
    //         .querySelectorAll(".modal-backdrop")
    //         .forEach((el) => el.classList.remove("modal-backdrop"));
    //       props.onpress();
    //       props?.prop?.onPress();
    //       props?.prop?.cretae();
    //       //   document
    //       //     .querySelectorAll(".modal-backdrop")
    //       //     .forEach((el) => el.classList.remove("modal-backdrop"));
    //       // props.onpress(false);
    //       navigate("/ticketdetail", { state: { data: result?.data } });
    //       props.onload();
    //       setLoading(false);
    //     } else {
    //       setLoading(false);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     // setLoading(false);
    //   });
  };

  const deleteDefaultService = async (categoryId, subcategoryId) => {
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${baseurl}deleteDefaultServices`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          categoryId,
          subcategoryId,
        }),
      });

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("API delete error:", error);
      return { status: false, message: "An error occurred." };
    }
  };

  return (
    <>
      <div
        className="modal-dialog modal-dialog-centered cusmodal_xl"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="editrepairproductModalLabel">
              Edit Repair Products
            </h5>
            <button
              type="button"
              className="close"
              // data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                if (props?.onload?.()) {
                  props?.onpress?.();
                  props?.onload?.();
                }
                props?.onClose1();
                props?.onpress?.();
                document
                  .querySelectorAll(".modal-backdrop")
                  .forEach((el) => el.classList.remove("modal-backdrop"));
                // props?.onload();
              }}
              // onClick={() => {
              //   props?.onpress();
              //   props?.onload();
              // }}
            >
              <span className="close_icon" />
            </button>
            <p>Select customer device brand and model</p>
          </div>
          <div className="modal-body">
            <div className="custom_form editrepairproduct_form">
              <div className="add_repair_service_btn">
                <button
                  type="button"
                  //   data-toggle="modal"
                  //   data-target="#addrepairserviceModal"
                  onClick={(e) => {
                    e.preventDefault(); // prevent default navigation
                    setShowModel(true);
                  }}
                >
                  <i className="fa fa-plus" /> Add Repair &amp; Services
                </button>
              </div>
              <form
                action=""
                method=""
                className="cus_form"
                data-gtm-form-interact-id={0}
              >
                <div className="repair_service_left">
                  <div className="form_row">
                    <div className="form_column col_full">
                      <div className="form-group">
                        <label className="cus_label">
                          Device Model<span>*</span>
                        </label>
                        <div className="formfield add_cust_field">
                          <input
                            type="text"
                            className="form-control"
                            name="devicemodel"
                            placeholder="Device Name"
                            defaultValue={props?.product}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form_column col_full">
                      <div className="form-group">
                        <label className="cus_label">
                          Device Parent Brand<span>*</span>
                        </label>
                        <div className="formfield add_cust_field">
                          <input
                            type="text"
                            className="form-control"
                            name="devicebrand"
                            placeholder="Device Brand"
                            defaultValue={props?.Brand}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form_column col_full">
                      <div className="form-group">
                        <label className="cus_label">
                          Device Series Line<span>*</span>
                        </label>
                        <div className="formfield add_cust_field">
                          <input
                            type="text"
                            className="form-control"
                            name="deviceseriesline"
                            placeholder="Device Series Line"
                            defaultValue={props?.series}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="repair_service_right">
                  <div className="repair_product_table">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Repair &amp; Services</th>
                            <th>Stock</th>
                            <th>Cost ($)</th>
                            <th>Price ($)</th>
                            <th>Profit</th>
                            <th>Margin</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {defaultServices.map((categoryItem, catIndex) => (
                            <tr key={catIndex}>
                              <td
                                className="main_td active"
                                colSpan={7}
                                onClick={() => {
                                  handleCategoryClick(catIndex);
                                  setSubcategoryNames(categoryItem.category);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="main_td_heading">
                                  <i className="fa fa-angle-right" />{" "}
                                  {categoryItem.category}
                                </span>
                                {expandedCategoryIndex === catIndex && (
                                  <table style={{ width: "100%" }}>
                                    <tbody>
                                      {categoryItem.subcategories.map(
                                        (subItem, subIndex) => (
                                          <tr key={subItem.id}>
                                            <td>
                                              <div className="checkbox">
                                                <input
                                                  type="checkbox"
                                                  name="prd_chk_val"
                                                  value=""
                                                  onClick={(e) =>
                                                    e.stopPropagation()
                                                  }
                                                  checked={
                                                    selectedSubcategories?.[
                                                      `${categoryItem.id}_${subItem.id}`
                                                    ] || false
                                                  }
                                                  onChange={(e) => {
                                                    const key = `${categoryItem.id}_${subItem.id}`;
                                                    const checked =
                                                      e.target.checked;
                                                    setSelectedSubcategories(
                                                      (prev) => ({
                                                        ...prev,
                                                        [key]: checked,
                                                      })
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </td>
                                            <td>{subItem.name || "N/A"}</td>
                                            <td className="td_input_field">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder={subItem.stock || 0}
                                                name="stock_td"
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setEditedFields((prev) => ({
                                                    ...prev,
                                                    [`${categoryItem.id}_${subItem.id}`]:
                                                      {
                                                        ...(prev[
                                                          `${categoryItem.id}_${subItem.id}`
                                                        ] || {}),
                                                        categoryId:
                                                          categoryItem.id,
                                                        subcategoryId:
                                                          subItem.id,
                                                        stock: Number(value),
                                                      },
                                                  }));
                                                }}
                                              />
                                            </td>
                                            <td className="td_input_field">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder={subItem.cost || 0}
                                                name="cost_td"
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setEditedFields((prev) => ({
                                                    ...prev,
                                                    [`${categoryItem.id}_${subItem.id}`]:
                                                      {
                                                        ...(prev[
                                                          `${categoryItem.id}_${subItem.id}`
                                                        ] || {}),
                                                        categoryId:
                                                          categoryItem.id,
                                                        subcategoryId:
                                                          subItem.id,
                                                        cost: Number(value),
                                                      },
                                                  }));
                                                }}
                                              />
                                            </td>
                                            <td className="td_input_field">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder={subItem.price || 0}
                                                name="price_td"
                                                onClick={(e) =>
                                                  e.stopPropagation()
                                                }
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setEditedFields((prev) => ({
                                                    ...prev,
                                                    [`${categoryItem.id}_${subItem.id}`]:
                                                      {
                                                        ...(prev[
                                                          `${categoryItem.id}_${subItem.id}`
                                                        ] || {}),
                                                        categoryId:
                                                          categoryItem.id,
                                                        subcategoryId:
                                                          subItem.id,
                                                        price: Number(value),
                                                      },
                                                  }));
                                                }}
                                              />
                                            </td>
                                            <td
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                            >
                                              {(() => {
                                                const key = `${categoryItem.id}_${subItem.id}`;
                                                const edited =
                                                  editedFields[key] || {};
                                                const price =
                                                  edited.price ??
                                                  subItem.price ??
                                                  0;
                                                const cost =
                                                  edited.cost ??
                                                  subItem.cost ??
                                                  0;
                                                const profit = price - cost;
                                                return profit;
                                              })()}
                                            </td>
                                            <td
                                              onClick={(e) =>
                                                e.stopPropagation()
                                              }
                                            >
                                              {(() => {
                                                const key = `${categoryItem.id}_${subItem.id}`;
                                                const edited =
                                                  editedFields[key] || {};
                                                const price =
                                                  edited.price ??
                                                  subItem.price ??
                                                  0;
                                                const cost =
                                                  edited.cost ??
                                                  subItem.cost ??
                                                  0;
                                                const profit = price - cost;
                                                const margin =
                                                  price !== 0
                                                    ? Math.round(
                                                        (profit / price) * 100
                                                      )
                                                    : 0;
                                                return `${margin}%`;
                                              })()}
                                            </td>
                                            <td>
                                              <div className="rep_prod_action_btn">
                                                <a
                                                  href="#"
                                                  //   data-toggle="modal"
                                                  //   data-target="#editrepairserviceModal"
                                                  className="repedit_btn"
                                                  onClick={(e) => {
                                                    e.stopPropagation();

                                                    e.preventDefault();
                                                    setShowModel1(true);
                                                    setIsEditMode(true);
                                                    setSubcategoryName(
                                                      subItem.name
                                                    ); // Pre-fill name
                                                    setSubcategoryId(
                                                      subItem.id
                                                    ); // Set subcategory ID for update
                                                    setSelectedCategoryId(
                                                      categoryItem.id
                                                    ); // Set selected category
                                                    setSubcategoryNames(
                                                      "Issue"
                                                    ); // For modal title
                                                  }}
                                                >
                                                  <img
                                                    src="assets/img/repair-edit-action-icon.png"
                                                    alt=""
                                                  />
                                                </a>
                                                <a
                                                  href="#"
                                                  className="reptrash_btn"
                                                  onClick={async (e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();

                                                    const result =
                                                      await Swal.fire({
                                                        title: "Are you sure?",
                                                        text: "Do you really want to delete this service?",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        customClass: {
                                                          container:
                                                            "custom-swal-container",

                                                          confirmButton:
                                                            "custom-swal-confirm-button",
                                                        },
                                                        confirmButtonColor:
                                                          "#3085d6",
                                                        cancelButtonColor:
                                                          "#d33",
                                                        confirmButtonText:
                                                          "Yes, delete it!",
                                                      });

                                                    if (result.isConfirmed) {
                                                      const response =
                                                        await deleteDefaultService(
                                                          categoryItem.id,
                                                          subItem.id
                                                        );

                                                      if (response.status) {
                                                        Swal.fire({
                                                          title:
                                                            "Service has been deleted.",

                                                          customClass: {
                                                            container:
                                                              "custom-swal-container",

                                                            confirmButton:
                                                              "custom-swal-confirm-button",
                                                          },
                                                        });
                                                        GetAllDefaultServices(); // Refresh data
                                                      } else {
                                                        Swal.fire({
                                                          title:
                                                            "Failed to delete service.",

                                                          customClass: {
                                                            container:
                                                              "custom-swal-container",

                                                            confirmButton:
                                                              "custom-swal-confirm-button",
                                                          },
                                                        });
                                                      }
                                                    }
                                                  }}
                                                >
                                                  <img
                                                    src="assets/img/repair-trash-action-icon.png"
                                                    alt=""
                                                  />
                                                </a>
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <td colSpan={4}>
                                          <button
                                            type="button"
                                            className="add_item_btn"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setShowModel1(true);
                                              setSelectedCategoryId(
                                                categoryItem.id
                                              );
                                            }}
                                          >
                                            <i className="fa fa-plus" /> Add
                                            Item
                                          </button>
                                        </td>
                                        <td colSpan={3}>
                                          <button
                                            type="button"
                                            className="save_item_btn"
                                            onClick={handleSaveChanges}
                                          >
                                            Save Changes
                                          </button>
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary cancel_btn mr-auto"
              // data-dismiss="modal"
              onClick={() => {
                if (props?.onload?.()) {
                  props?.onpress?.();
                  props?.onload?.();
                }
                props?.onpress?.();
                props?.onBack1();
                // props?.onload();
              }}
            >
              Back
            </button>
            {/* <button
              type="button"
              className="btn btn-primary success_btn"
              onClick={() => AddTicket()}
            >
              Create Ticket
            </button> */}
          </div>
        </div>
      </div>
      {showModal && (
        <>
          <div
            className="modal show d-block common_modal addrepairservice_modal cus_repair_modal"
            id="addrepairserviceModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="addrepairserviceModalLabel"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered cusmodal_sm"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="addrepairserviceModalLabel">
                    New Repair and Service Type
                  </h5>
                  <button
                    type="button"
                    className="close"
                    // data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setShowModel(false)}
                  >
                    <span className="close_icon" />
                  </button>
                </div>
                <div className="modal-body">
                  <div className="custom_form addcustom_form">
                    <form
                      action=""
                      method=""
                      className="cus_form"
                      data-gtm-form-interact-id={0}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form_column col_full">
                            <div className="form-group">
                              <label className="cus_label">
                                Name<span>*</span>
                              </label>
                              <div className="formfield selectcustomerboxcustmlist">
                                <input
                                  type="text"
                                  name="repairname"
                                  className="form-control"
                                  placeholder="Enter Name of Repair"
                                  value={categoryName}
                                  onChange={(e) =>
                                    setCategoryName(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="submit_modal_btn">
                        <button
                          type="button"
                          className="btn btn-default cancel_btn"
                          onClick={() => setShowModel(false)}
                          //   data-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary theme_btn"
                          onClick={AddCategory}
                        >
                          Add
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showModal1 && (
        <>
          <div
            className="modal show d-block common_modal editrepairservice_modal cus_repair_modal"
            id="editrepairserviceModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="editrepairserviceModalLabel"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered cusmodal_sm"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="editrepairserviceModalLabel">
                    {isEditMode
                      ? `Edit ${subcategoryNames} in ${subcategoryName}`
                      : `Add ${subcategoryNames} in ${subcategoryName}`}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    // data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setShowModel1(false);
                      setIsEditMode(false);
                      setSubcategoryName("");
                    }}
                  >
                    <span className="close_icon" />
                  </button>
                </div>
                <div className="modal-body">
                  <div className="custom_form addcustom_form">
                    <form
                      action=""
                      method=""
                      className="cus_form"
                      data-gtm-form-interact-id={0}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form_column col_full">
                            <div className="form-group">
                              <label className="cus_label">
                                Issue Name<span>*</span>
                              </label>
                              <div className="formfield selectcustomerboxcustmlist">
                                <input
                                  type="text"
                                  name="issuename"
                                  className="form-control"
                                  placeholder="Enter Name of Issue"
                                  value={subcategoryName}
                                  onChange={(e) =>
                                    setSubcategoryName(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="submit_modal_btn">
                        <button
                          type="button"
                          className="btn btn-default cancel_btn"
                          onClick={() => {
                            setShowModel1(false);

                            setIsEditMode(false);
                            setSubcategoryName("");
                          }}
                          //   data-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary theme_btn"
                          onClick={() => {
                            if (isEditMode) {
                              UpdateSubCategory(); // Call update API
                            } else {
                              AddSubCategory(); // Existing function for adding
                            }
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default DefaultServiceModel;
